import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface ButtonTabItem {
  id: string | number;
  label: string;
  isActive: boolean;
  icon?: string;
  iconTooltip?: string;
}

export interface ContextualMenuItem {
  id: string | number;
  label: string;
  onClick: (item: this, tabParent: ButtonTabItem) => void;
}

@Component({
  selector: 'miq-button-tabs',
  templateUrl: './button-tabs.component.html',
  styleUrls: ['./button-tabs.component.scss'],
  standalone: false,
})
export class ButtonTabsComponent {
  @Input() tabItems: ButtonTabItem[];
  @Input() contextualMenuItems: ContextualMenuItem[];
  @Output() onTabSelected = new EventEmitter<ButtonTabItem>();

  tabSelected(tab: ButtonTabItem) {
    if (tab.isActive) return;
    this.tabItems.forEach(tab => (tab.isActive = false));
    tab.isActive = true;
    this.onTabSelected.emit(tab);
  }
}
